function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    height: 120,
    width: 120,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M292.03,509.464c100.421-14.148,182.122-86.545,209.829-181.932L361.915,187.589l-49.355,3.839 l-60.049-60.049l-24.093,18.889l-3.16,4.31l-42.277,40.093l74.993,74.993l-144.196,61.549L292.03,509.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F4F"
    },
    d: "M113.778,331.212c0-57.822,46.875-104.696,104.696-104.696S323.17,273.391,323.17,331.212H113.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35933"
    },
    d: "M220.086,226.557v104.655H323.17C323.17,273.93,277.161,227.421,220.086,226.557z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7F4F"
    },
    cx: 220.16,
    cy: 165.685,
    r: 47.161
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35933"
    },
    d: "M220.162,118.519c-0.026,0-0.05,0.002-0.076,0.002v94.317c0.026,0,0.05,0.002,0.076,0.002 c26.046,0,47.161-21.114,47.161-47.161C267.323,139.633,246.208,118.519,220.162,118.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M378.613,304.499h-15.515v-80.551c0-17.93-14.588-32.518-32.516-32.518 c-17.93,0-32.518,14.588-32.518,32.518v80.551h-15.515v-80.551c0-26.486,21.547-48.033,48.033-48.033 c26.484,0,48.031,21.547,48.031,48.033V304.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M330.581,175.914c-0.055,0-0.11,0.003-0.165,0.003v15.519c0.055,0,0.109-0.009,0.165-0.009 c17.929,0,32.516,14.588,32.516,32.518v80.551h15.515v-80.551C378.613,197.461,357.066,175.914,330.581,175.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC61B"
    },
    d: "M387.348,372.031H273.813c-6.732,0-12.19-5.458-12.19-12.19v-90.55c0-6.732,5.458-12.19,12.19-12.19 h113.535c6.732,0,12.19,5.458,12.19,12.19v90.55C399.538,366.573,394.08,372.031,387.348,372.031z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M387.348,257.103h-56.932v114.928h56.932c6.732,0,12.19-5.458,12.19-12.19v-90.55 C399.538,262.561,394.08,257.103,387.348,257.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M346.958,304.178c0-9.045-7.332-16.377-16.377-16.377s-16.377,7.332-16.377,16.377 c0,6.058,3.298,11.335,8.189,14.169v18.337c0,4.522,3.667,8.189,8.189,8.189c4.522,0,8.189-3.667,8.189-8.189v-18.337 C343.659,315.513,346.958,310.236,346.958,304.178z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5419"
    },
    d: "M330.581,287.801c-0.055,0-0.109,0.009-0.165,0.009v57.047c0.057,0.002,0.109,0.017,0.165,0.017 c4.522,0,8.189-3.667,8.189-8.189v-18.337c4.891-2.832,8.189-8.109,8.189-14.169C346.958,295.133,339.625,287.801,330.581,287.801z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.dbfb4949f5035b1fbd49da06335466af.svg";
export { ForwardRef as ReactComponent };